import React, { useState, useEffect } from 'react';
import { Layout, Typography, List, Space, Divider, Button } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { GetCertification } from '../../api/AdminService';
import { useParams } from 'react-router-dom';
import { usePDF } from 'react-to-pdf';
import jsPDF from 'jspdf';

const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;
const Certification = () => {
  const { id } = useParams();
  const [Certification, setCertification] = useState()
  const { toPDF, targetRef } = usePDF({
    filename: 'certification.pdf',
    page: {
      format: [200,189],
    }
  });
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const GetCertificate = (id) => {
    GetCertification(id).then(res => {
      if (res.status === 200) {
        
        console.log(res.data)
        setCertification(res.data)
      }
    })
  }


    useEffect(() => {
      GetCertificate(id);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <button onClick={() => toPDF()} style={{ backgroundColor: '#008CBA', color: 'white', padding: '5px 10px', borderRadius: '5px', display: 'block', margin: '0 auto' }}>Download PDF</button>
      <Layout>
        <Content style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}

        >

          <div style={{
            display: 'flex',
            flexDirection: screenWidth < 768 ? 'column' : 'row',
            gap: '40px',
            backgroundColor: '#fff',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            height: '1000px'
          }} ref={targetRef}>
            {/* Left Sidebar */}
            <div style={{
              width: '300px',
              backgroundColor: '#485769',
              padding: '20px',
              color: 'white',
            }}>
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <div style={{
                  width: '150px',
                  height: '150px',
                  margin: '0 auto 20px',
                  padding: '20px',
                  backgroundColor: 'white',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img
                    src="/logo-langmai-4.jpg"
                    alt="Coursera Logo"
                    style={{ width: '90%', height: 'auto' }}
                  />
                </div>

              </div>



            </div>

            <div style={{ flex: 1, padding: '40px' }}>

              <Text type="secondary">{Certification?.endDate}</Text>

              <Title level={2} style={{ marginTop: '10px', marginBottom: '30px' }}>
                {Certification?.dharmaName}
              </Title>
              <Text type="secondary" style={{ marginBottom: '30px' }}>
                {Certification?.name} { }
              </Text>

              <Text>
                has successfully completed the meditation retreat at Làng Mai (Plum Village) in Thailand.
              </Text>

              <Title level={1} style={{ marginTop: '20px', marginBottom: '30px' }}>
                {Certification?.retreatName}
              </Title>

              <Paragraph style={{ fontSize: '16px', marginBottom: '40px' }}>
                This certification from Làng Mai is awarded upon the successful completion of a meditation retreat, where participants engaged in various mindfulness practices over [Duration]. The learner has gained a deep understanding of core Buddhist teachings and meditation techniques, including sitting meditation, walking meditation, and mindful breathing. Throughout the retreat, [he/she/they] practiced self-reflection, participated in community activities, and embraced the principles of compassion and mindfulness. The earner of this certification has demonstrated proficiency in applying meditation practices in daily life, fostering inner peace and awareness, and is now equipped with skills to enhance personal well-being and contribute positively to the community.
              </Paragraph>

              <div style={{ marginTop: '10px' }}>
                <img
                  src="/Ha_ signature.jpg"
                  alt="Signature"
                  style={{ marginBottom: '10px' }}
                />
                <Text strong display="block" style={{ marginLeft: 150 }}>Ha, Monk</Text>
              </div>
            </div>
          </div>
        </Content>
      </Layout>
    </div>
  );
}

export default Certification